export const TOP_NAV_LOGO = process.env.PUBLIC_URL + '/nrna-aus-logo-title.png';
export const NEWS_FALLBACK_BANNER = process.env.PUBLIC_URL + '/16-9-logo-filler.png';
export const FOOTER_LOGO = process.env.PUBLIC_URL + '/nrna-logo-200px.png';
export const PAGE_NOT_FOUND_IMAGE = process.env.PUBLIC_URL + '/404-error.png';
export const TEAM_FALLBACK_IMAGE = process.env.PUBLIC_URL + '/nrna-logo-200px.png';